import api from '@/api/routes'
import wx from 'weixin-js-sdk'

let jssdk = () => {
  window._wx = wx
  setTimeout(() => {
    api
      .weChatJssdk({
        url: window.location.href
      })
      .then((res) => {
        if (typeof res === 'boolean' && !res) return
        wx.config({
          debug: process.env.NODE_ENV == 'production' ? false : true,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
        })
      })
  }, 25)
}

export default jssdk
